// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './libs/rem.js'
import {
  Base,
  Curren
} from './assets/js/Base'
import api from './assets/js/api'
import $ from 'jquery'
import pageMove from './components/pageMove'
import hotzy from './components/rmzy.vue'
import BaiduMap from 'vue-baidu-map'
import store from './store' //引入store


Vue.use(pageMove)
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'YOUR_APP_KEY'
})

//判断是否外链组件
var Profile = Vue.extend({
  template: '<router-link :class="myClass" :to="{path:url,query:param}" v-if="!isOutUrl" v-html="content"></router-link><a :class="myClass" :href="url" v-else v-html="content"></a>',

  data: function () {
    return {
      isOutUrl: false,
      thatQuery: {}
    }
  },
  props: ["url", "param", "content", "myClass"],
  mounted() {
    if (/^http/.test(this.url) || /javascript/.test(this.url)) {
      this.isOutUrl = true;
    } else {
      this.isOutUrl = false;
    }
  }
})

Vue.component('hrefformat', Profile)
Vue.component('hotzy', hotzy)


Vue.config.productionTip = false
Vue.prototype.Base = Base
Vue.prototype.Curren = Curren
Vue.prototype.baseURL = ''
Vue.prototype.api = api
Vue.prototype.bdsq = 'https://tb.53kf.com/code/client/8e60a251e3532919b1f823bfdf0c23943/8'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js